// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1NQOO","title":"AfterFrontImage_title__yVOdH"};